// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2497ed","colorSecondary":"#eaf5fe","chartItem":"Charts_chartItem__3Vu6u","ChartContainer":"Charts_ChartContainer__1zv3j"};